import { defineQueries } from '@rocicorp/zero';
import { basicDataQueries } from './basic-data.queries.js';
import { compoundersQueries } from './compounders.queries.js';
import { customerQueries } from './customers.queries.js';
import { drugCatalogQueries } from './drug-catalog.queries.js';
import { eventLogsQueries } from './event-log.queries.js';
import { hl7EventsQueries } from './hl7-event-log.queries.js';
import { locationsQueries } from './location.queries.js';
import { patientsQueries } from './patient.queries.js';
import { patientsTherapiesQueries } from './patients-therapies.queries.js';
import { pharmaciesQueries } from './pharmacies.queries.js';
import { productsQueries } from './products.queries.js';
import { protocolsQueries } from './protocols.queries.js';
import { reportsQueries } from './reports.queries.js';
import { settingsQueries } from './settings.queries.js';
import { stocksQueries } from './stocks.queries.js';
import { userGroupsQueries } from './user-group.queries.js';
import { usersQueries } from './user.queries.js';
export { ListAdminRoutesFiltersInput, ListAdminRoutesInput, ListBasicDataFiltersInput, ListBasicDataInput, ListCategoriesFiltersInput, ListCategoriesInput, ListCompaniesFiltersInput, ListCompaniesInput, ListContainerMaterialsFiltersInput, ListContainerMaterialsInput, ListContainerTypesFiltersInput, ListContainerTypesInput, ListDiagnosesFiltersInput, ListDiagnosesInput, ListHazardClassesFiltersInput, ListHazardClassesInput, ListInsuranceCompaniesFiltersInput, ListInsuranceCompaniesInput, ListStockLocationsFiltersInput, ListStockLocationsInput, ListTreatmentChairsFiltersInput, ListTreatmentChairsInput, } from './basic-data.queries.js';
export { ListCustomersInput } from './customers.queries.js';
export { ListCompoundMappingsInput, ListCompoundOrdersByOrderInput, ListCompoundOrdersBySequenceInput, ListCompoundOrdersInput, } from './compounders.queries.js';
export { activeSubstancePopulates, ListActiveSubstancesFiltersInput, ListDrugCatalogItemsInput, ListActiveSubstancesInput, ListSolutionsFiltersInput, ListSolutionsInput, ListSupportiveMedicationsFiltersInput, ListSupportiveMedicationsInput, NO_CATEGORIES_FILTER, solutionPopulates, SolutionType, supportiveMedicationPopulates, } from './drug-catalog.queries.js';
export { ListPatientsInput, } from './patient.queries.js';
export { ListOrdersFilters, ListOrdersInput, ListPatientTherapySequencesFilters, ListPatientTherapySequencesInput, ProductionStatusKey, } from './patients-therapies.queries.js';
export { ListPharmaciesInput } from './pharmacies.queries.js';
export { createPopulateSchema } from './populates.js';
export { ListConsumablesFiltersInput, ListConsumablesInput, ListTradeNamesFiltersInput, ListTradeNamesInput, ListPrescribedNamesInput, ListUnitsFiltersInput, ListUnitsInput, tradeNamePopulates, } from './products.queries.js';
export { ListProtocolsInput } from './protocols.queries.js';
export { ListPrescriptionReportInput, PrescriptionReportFilters, PrescriptionReportDateBasis, ListStockMovementsInput, StockMovementReportFilters, ListReportViewsInput, } from './reports.queries.js';
export { DiscardType, ListDiscardsInput, ListRestVialsInput, ListReturnsInput } from './stocks.queries.js';
export { ListUserGroupsFiltersInput, ListUserGroupsInput } from './user-group.queries.js';
export { ListUsersFiltersInput, ListUsersInput } from './user.queries.js';
export { EXPIRING_DAYS_THRESHOLD, SearchBatchesInput, StockStatus, stockStatusList } from './stocks.queries.js';
export { EventLogStatusSchema } from './event-log.queries.js';
export { getSettings } from './settings.queries.js';
export { ListHl7EventsFiltersInput } from './hl7-event-log.queries.js';
export const queries = defineQueries({
    customers: customerQueries,
    pharmacies: pharmaciesQueries,
    locations: locationsQueries,
    products: productsQueries,
    userGroups: userGroupsQueries,
    users: usersQueries,
    patients: patientsQueries,
    hl7Events: hl7EventsQueries,
    eventLogs: eventLogsQueries,
    basicData: basicDataQueries,
    protocols: protocolsQueries,
    drugCatalog: drugCatalogQueries,
    patientsTherapies: patientsTherapiesQueries,
    reports: reportsQueries,
    settings: settingsQueries,
    stocks: stocksQueries,
    compounders: compoundersQueries,
});
//# sourceMappingURL=index.js.map